module.exports = __webpack_public_path__ + "img/sgbci.730af684.png";